import {
  TerminateEmployeeDocument,
  TerminateEmployeeMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useTerminateEmployee = () => {
  const [terminateEmployee, { loading }] = useMutation(TerminateEmployeeDocument, {
    extractorFn: (data) => data.employeesMutations.terminateEmployeesEmployee,
  })

  return {
    loading,
    terminate(variables: TerminateEmployeeMutationVariables) {
      return terminateEmployee({
        variables,
      })
    },
  }
}
